// HomeBanner.js
import React from "react";
import { Link } from "react-router-dom";
import banner1 from "../../assets/images/banner-01.jpg";
import banner2 from "../../assets/images/banner-02.jpg";
import banner3 from "../../assets/images/banner-03.jpg";

const banners = [
  {
    id: 1,
    image: banner1,
    title: "Women",
    subtitle: "Spring 2018",
    link: "/shop?category=women",
  },
  {
    id: 2,
    image: banner2,
    title: "Men",
    subtitle: "Spring 2018",
    link: "/shop?category=men",
  },
  {
    id: 3,
    image: banner3,
    title: "Accessories",
    subtitle: "New Trend",
    link: "/shop?category=accessories",
  },
];

const HomeBanner = () => {
  return (
    <div className="py-5 bg-light">
      <div className="container">
        <div className="row">
          {banners.map((banner) => (
            <div key={banner.id} className="col-md-6 col-xl-4 mb-4">
              <div className="position-relative overflow-hidden rounded-3 shadow-sm">
                <img
                  src={banner.image}
                  alt={banner.title}
                  className="img-fluid w-100"
                  style={{ objectFit: "cover", height: "100%" }}
                />
                <Link
                  to={banner.link}
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-between p-4 banner-link"
                  style={{ textDecoration: "none" }}
                >
                  <div>
                    <h5 className="fw-bold mb-1 banner-title">
                      {banner.title}
                    </h5>
                    <p className="mb-0 banner-subtitle">{banner.subtitle}</p>
                  </div>
                  <div className="fw-semibold text-uppercase shop-now">
                    Shop Now
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
